module.exports = __webpack_public_path__ + "static/media/times.d5209bce.svg";